// extracted by mini-css-extract-plugin
export default {"employee-container":"PayGroup_employee-container__4TDYW"};